import { render, staticRenderFns } from "./AttivitaList.vue?vue&type=template&id=75017fa4&"
import script from "./AttivitaList.vue?vue&type=script&lang=ts&"
export * from "./AttivitaList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports